import { render, staticRenderFns } from "./contentModule.vue?vue&type=template&id=1955dfc6&scoped=true"
import script from "./contentModule.vue?vue&type=script&lang=ts"
export * from "./contentModule.vue?vue&type=script&lang=ts"
import style0 from "./contentModule.vue?vue&type=style&index=0&id=1955dfc6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1955dfc6",
  null
  
)

export default component.exports